import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import cn from 'classnames';

import { Loader } from '../../../components/Loader';
import { Button } from '../../../components/Buttons';
import { HBox, VBox } from '../../../components/Box';
import { List, Row } from '../../../components/List';
import { Edit, Times } from '../../../components/Icon';
import { getPropByName } from '../../../utils/props';
import { fetchVehicle, setVehicleProperty } from '../../Vehicles/actions';
import { selectUser } from '../../Users/selectors';
import { selectMe, selectWorks } from '../../Api/selectors';
import { REQUEST_VEHICLE, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../Vehicles/constants';
import { REQUEST_USER } from '../../Users/constants';
import { selectVehicle } from '../../Vehicles/selectors';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getRemarkType } from '../cells/helpers/getRemarkType';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';

import styles from './KanbanVehicleRemarks.module.css';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
dayjs.extend(customParseFormat);
const Container = styled.div`
  font-size: 14px;
  width: ${props => (props.vehicleTaskRemarks || props.fullWidth ? '100%' : '')};


  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }

  .icon-cross {
    cursor: pointer;
    font-size: 18px;
    width: 20px;
    height: 22px;
  }

  .icon-edit-square {
    color: #0183D5;
  }

  .fa-square-xmark {
    padding: 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;

    background-color: #d50046;
    color: #fff;
  }

  align-items: center;

  .remark {
    margin-bottom: 10px;
    min-height: 60px;

    .initials-wrapper {
      width: 40px;
      height: 40px;
      background-color: rgba(29, 155, 209, 0.1);
      justify-content: center;
      border-radius: 50%;
    }

    .text {
      width: 85%;
      text-align: start;
    }
  }

  .text-input {
    width: 100%;
        height: 200px; !important;
    resize: none;
  }
  textarea {
    height: 200px; !important
  }
`;

const STATE = {
  isOpenAddModal: false,
  remarks: [],
  newRemarkText: '',
  editableRemark: null,
};
/* eslint-disable react/prefer-stateless-function */
class KanbanVehicleRemarksComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.fetchedVehicle?.id) {
      getPropByName(this.props.fetchedVehicle, this.remarksType) &&
        this.setState({ remarks: JSON.parse(getPropByName(this.props.fetchedVehicle, this.remarksType)) });

      return;
    }
    this.props.fetchVehicle(result => {
      if (result?.id) {
        getPropByName(this.vehicle, this.remarksType) &&
          this.setState({ remarks: JSON.parse(getPropByName(this.vehicle, this.remarksType)) });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.fetchedVehicle?.id) {
      const remarks = getPropByName(this.props.fetchedVehicle, this.remarksType);
      let parsedRemarks = remarks ? JSON.parse(remarks) : [];

      if (!remarks?.length) return;

      if (parsedRemarks?.length !== this.state.remarks?.length) {
        this.setState({ remarks: JSON.parse(remarks) });
      }
      return;
    }

    if (this.props.vehicle?.id) {
      const remarks = getPropByName(this.props.vehicle, this.remarksType);
      let parsedRemarks = remarks ? JSON.parse(remarks) : [];

      if (!remarks?.length) return;

      if (parsedRemarks?.length !== this.state.remarks?.length) {
        this.setState({ remarks: JSON.parse(remarks) });
      }
    }
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get remarkDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY HH:mm');
  }

  get sortingDate() {
    return new Date(Date.now());
  }

  get remarksType() {
    return getRemarkType(this.props.taskName);
  }

  get sortedRemarks() {
    return this.state.remarks?.sort((a, b) => (b?.sortingDate < a?.sortingDate ? -1 : 1));
  }

  handleModalOpen(remark = null) {
    this.setState({
      isOpenAddModal: true,
      editableRemark: remark?.id || null,
      newRemarkText: remark?.text || '',
    });
  }

  onMouseOverMessage() {
    return this.sortedRemarks?.[0]?.text || '';
  }

  renderInitials(name, surname) {
    return (
      <HBox vCenter>
        <HBox className="initials-wrapper" vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <HBox vCenter right>
          <strong>{name ?? ''}</strong>
          &nbsp;
          <strong>{surname ?? ''}</strong>
        </HBox>
      </HBox>
    );
  }

  reset() {
    this.setState({ isOpenAddModal: false, newRemarkText: '', editableRemark: null });
  }

  onSave() {
    const { loggedUser, setRemark } = this.props;
    const { newRemarkText, remarks } = this.state;

    const remark = {
      id: Date.now(),
      userId: loggedUser?.id,
      text: newRemarkText,
      name: getPropByName(loggedUser, 'name'),
      surname: getPropByName(loggedUser, 'surname'),
      kanbanBoardLabel: this.props.kanbanBoardLabel ?? '',
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const updatedRemarks = [...remarks, remark];

    setRemark(JSON.stringify(updatedRemarks), result => {
      if (result) {
        this.reset();
      }
    });
  }

  onEdit(remarkId) {
    const { loggedUser, setRemark } = this.props;
    const { newRemarkText, remarks } = this.state;

    const remark = {
      id: remarkId,
      userId: loggedUser?.id,
      text: newRemarkText,
      name: getPropByName(loggedUser, 'name'),
      surname: getPropByName(loggedUser, 'surname'),
      kanbanBoardLabel: this.props.kanbanBoardLabel ?? '',
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const updatedRemarks = remarks?.filter(remark => remark?.id != remarkId);
    updatedRemarks.push(remark);
    setRemark(JSON.stringify(updatedRemarks));
  }

  onDelete(remarkId) {
    const remarks = this.state.remarks?.filter(remark => remark?.id != remarkId);

    this.props.setRemark(JSON.stringify(remarks));
  }

  renderAddModal() {
    const nl2br = text => {
      return { __html: text?.replace(/(?:\r\n|\r|\n)/g, '<br>') };
    };
    return (
      <ModalComponent
        size={'modal-lg'}
        title={this.state.editableRemark ? this.lbl('info.remarks.edit') : this.lbl('info.remarks.add')}
        onClose={this.reset.bind(this)}
      >
        <Wrapper>
          {Array.isArray(this.state.remarks) &&
  this.state.remarks.map(remark => (
              <Row key={remark?.id} style={{ border: '1px solid black' }}>
                <div className={styles.remarkCard}>
                  <HBox vCenter right className="mt-3" style={{ gap: '10px' }}>
                    <ButtonComponent
                      style={'ButtonSoftEdit'}
                      disabled={env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id}
                      onClick={() => {
                        if (env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id) {
                          return;
                        }
                        this.handleModalOpen(remark);
                      }}
                    >
                      <Edit />
                    </ButtonComponent>
                    <ButtonComponent
                      style={'ButtonSoftDelete'}
                      disabled={env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id}
                      onClick={() => {
                        if (env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id) {
                          return;
                        }
                        this.onDelete(remark?.id);
                      }}
                    >
                      <Times />
                    </ButtonComponent>
                  </HBox>
                  <VBox className="remark" vCenter>
                    {remark?.name && remark?.surname && this.renderInitials(remark?.name, remark?.surname)}
                    <div className={styles.remarkText}>
                      <pre>
                        <h6 className="text" dangerouslySetInnerHTML={nl2br(remark?.text)}></h6>
                      </pre>
                    </div>
                  </VBox>
                  <HBox right>{remark?.date}</HBox>
                </div>
              </Row>
            ))}
        </Wrapper>
        <textarea
          className={cn('form-control', styles.Textarea)}
          value={this.state.newRemarkText}
          onChange={e => this.setState({ newRemarkText: e.target?.value })}
        />

        <div className="d-flex flex-column gap-2 mt-2">
          <ButtonComponent
            style={'ButtonSoftPrimaryFullWidth'}
            disabled={this.props.work}
            onClick={this.state.editableRemark ? () => this.onEdit(this.state.editableRemark) : this.onSave.bind(this)}
          >
            {this.state.editableRemark ? this.lbl('confirm') : this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftPrimaryFullWidth'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderRemarks(isModal) {
    const nl2br = text => {
      return { __html: text?.replace(/(?:\r\n|\r|\n)/g, '<br>') };
    };

    return (
      <Wrapper isModal={isModal} onClose={() => this.setState({ showRemarksList: false })}>
        {this.state.isOpenAddModal && this.renderAddModal(this.state.isEdit)}
        {Array.isArray(this.state.remarks) &&
  this.state.remarks.map(remark => (
            <Row key={remark?.id}>
              {!this.props.vehicleTaskRemarks && (
                <div className={styles.remarkCard}>
                  <HBox vCenter right>
                    <ButtonComponent
                      style={'ButtonSoftEdit'}
                      disabled={env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id}
                      onClick={() => {
                        if (env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id) {
                          return;
                        }
                        this.handleModalOpen(remark);
                      }}
                    >
                      <Edit />
                    </ButtonComponent>
                    <ButtonComponent
                      style={'ButtonSoftDelete'}
                      disabled={env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id}
                      onClick={() => {
                        if (env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id) {
                          return;
                        }
                        this.onDelete(remark?.id);
                      }}
                    >
                      <Times />
                    </ButtonComponent>
                  </HBox>
                </div>
              )}

              <VBox className="remark" vCenter>
                {remark?.name && remark?.surname && this.renderInitials(remark?.name, remark?.surname)}
                <p className="text" dangerouslySetInnerHTML={nl2br(remark?.text)}></p>
              </VBox>
              <HBox right>{remark?.date}</HBox>
            </Row>
          ))}
      </Wrapper>
    );
  }

  render() {
    if (this.props.work) return <Loader small />;

    if (!this.remarksType) return null;
    if (this.props.readOnly) {
      return (
        <Container vehicleTaskRemarks={this.props.vehicleTaskRemarks}>
          {this.state.isOpenAddModal && this.renderAddModal(this.state.isEdit)}
          {!this.props.vehicleTaskRemarks && (
            <HBox vCenter>
              {this.state.remarks?.length > 0 ? (
                <div className="icon-block" onClick={() => this.setState({ isOpenAddModal: true })}>
                  <img
                    src="https://vindat.indewal.nl/storage/documents/ca10dd49-aac5-4351-a014-a3cfeee9f88d.png"
                    style={{ width: '20px' }}
                  />
                </div>
              ) : (
                <div className="icon-block" onClick={() => this.setState({ isOpenAddModal: true })}>
                  +
                </div>
              )}
            </HBox>
          )}

          {this.state.showRemarksList && this.renderRemarks(true)}
          {this.props.vehicleTaskRemarks && this.renderRemarks(false)}
        </Container>
      );
    }

    if (this.props.readOnly && !this.state.remarks?.length) {
      return null;
    }

    console.log('render');
    return (
      <Container fullWidth={this.props.fullWidth}>
        {this.state.isOpenAddModal && this.renderAddModal(this.state.isEdit)}
        <HBox>
          <Button onClick={() => this.setState({ isOpenAddModal: true })}>{this.lbl('info.remarks.add')}</Button>
        </HBox>
        {this.renderRemarks(false)}
      </Container>
    );
  }
}

const Wrapper = ({ children, isModal, onClose }) => {
  if (isModal) {
    return (
      <ModalComponent onClose={onClose}>
        <Card className={cn('vehicle-info-card info-card data', styles.card)}>
          <List>{children}</List>
        </Card>
      </ModalComponent>
    );
  }
  return <List>{children}</List>;
};

KanbanVehicleRemarksComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_USER,
      `${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(ownProps.taskName)}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_VEHICLE,
    ]),
    loggedUser: selectUser(ownProps?.loggedUserId),
    me: selectMe(),
    vehicle: selectVehicle(ownProps.vehicleId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchVehicle(callback) {
      dispatch(fetchVehicle(ownProps.vehicleId, callback));
    },
    setRemark(dto, callback) {
      const remarksType = getRemarkType(ownProps.taskName);
      dispatch(setVehicleProperty(ownProps.vehicleId, remarksType, dto, callback, { taskRemarks: true }));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanVehicleRemarks = compose(withConnect, withRouter)(KanbanVehicleRemarksComp);
